import styled from "styled-components"

export const AlarmEventListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 360px;
    padding-bottom: 10px;
`;

export const AlarmEventItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    font-size: 14px;
    padding: 5px 5px;
    margin-top: 10px;
    border-radius: 5px;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
        background-color: rgba(0, 0, 0, 0.1);
    }
`;

export const AlarmEventItemRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
`;

export const DeviceName = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: bold;
`;

export const AlarmEventTime = styled.div`
    font-size: 11px;
`;

export const AlarmEventDetails = styled.div`
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: justify;
`;

export const NoAlarmEventsTips = styled.div`
    text-align: center;
    padding: 20px 0;
    color: #AAAAAA;
`;